<template>
    <v-card width="400px" class="mt-3 mb-6"
            :style="'border: solid ' + getPeriodColors(contactDiff).deep + ' 1px'">
        <v-app-bar dark :style="'background-color:' + getPeriodColors(contactDiff).light">
            <div class="d-flex justify-content-between w-100">
                <div class="mt-auto mb-auto cmaj-title">
                                                <span :style="'color:' + getPeriodColors(contactDiff).deep">
                                                    {{ data.first_name }}
                                                </span>
                    <span :style="'color:' + getPeriodColors(contactDiff).deep">
                                                    {{ data.last_name }}
                                                </span>
                </div>
            </div>
        </v-app-bar>

        <v-card-text>
            <div>
                <div class="mt-1 justify-content-between d-flex">
                    <div><b>Prénom</b></div>
                    <div v-if="data.first_name !== null"
                         style=" text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 50%;">
                        {{ data.first_name }}
                    </div>
                    <div v-else>Non renseigné</div>
                </div>

                <div class="mt-1 justify-content-between d-flex">
                    <div><b>Nom</b></div>
                    <div v-if="data.last_name !== null"
                         style=" text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 50%;">
                        {{ data.last_name }}
                    </div>
                    <div v-else>Non renseigné</div>
                </div>

                <div class="mt-1 justify-content-between d-flex">
                    <div><b>Téléphone</b></div>
                    <div v-if="data.phone !== null"
                         style=" text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 50%;">
                        {{ data.phone }}
                    </div>
                    <div v-else>Non renseigné</div>
                </div>

                <div class="mt-1 justify-content-between d-flex">
                    <div><b>Email</b></div>
                    <div v-if="data.email !== null"
                         style=" text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 50%;">
                        {{ data.email }}
                    </div>
                    <div v-else>Non renseigné</div>
                </div>

                <div class="mt-1 justify-content-between d-flex">
                    <div><b>Fonction du contact</b></div>
                    <div v-if="data.profession !== null"
                         style=" text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 50%;">
                        {{ data.profession.label }}
                    </div>
                    <div v-else>Non renseigné</div>
                </div>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapState } from "vuex"

export default {
    name: "ContactDiffCard",
    props: ["contactDiff", "data"],
    methods: {
        getPeriodColors(openingDiff) {
            if (openingDiff.old === null) {
                return this.addColors
            } else if (openingDiff.new !== null) {
                return this.updateColors
            } else {
                return this.deleteColors
            }
        },
    },
    computed: {
        ...mapState("sitAnswer", [
            "addColors",
            "updateColors",
            "deleteColors",
        ]),
    },
}
</script>